export {default as dispatch} from "./src/dispatch";



//////////////////
// WEBPACK FOOTER
// ./node_modules/d3-dispatch/index.js
// module id = 85
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14